import type { JSX } from "preact";
import { classNames } from "@gss/common/classNames";
import { Block } from "@gss/components/icons";
import { Table } from "@gss/components/Table";
import "./StatsTable.css";
import type { FilterSerie } from "../filters/filters.types";

interface Serie {
    filterSerie: FilterSerie;
}

interface Props<T> {
    title: string;
    className?: string;
    explanation?: string;
    subtitle?: string;
    categories: string[];
    series?: T[];
    callback: (serie: T) => (number | string | null)[];
}

export function StatsTable<T extends Serie>({
    title,
    className,
    explanation,
    subtitle,
    categories,
    series,
    callback,
}: Props<T>): JSX.Element {
    if (series == null) {
        return (
            <div className={classNames("stats-table-viewport", className)} />
        );
    }

    return (
        <div className={classNames("stats-table-viewport", className)}>
            <div>
                <h4>
                    {title}
                    {explanation != null && (
                        <>
                            <br />
                            <small className="highcharts-subtitle">
                                {explanation}
                            </small>
                        </>
                    )}
                    {subtitle != null && (
                        <>
                            <br />
                            <small className="highcharts-subtitle">
                                {subtitle}
                            </small>
                        </>
                    )}
                </h4>
                <Table
                    small
                    headers={
                        <tr>
                            <th />
                            {categories.map((c) => (
                                <th key={c}>{c}</th>
                            ))}
                        </tr>
                    }
                >
                    {series.map((s) => {
                        const values = callback(s);
                        return (
                            <tr key={s.filterSerie.key}>
                                <td>
                                    <Block
                                        aria-hidden
                                        style={{
                                            color: s.filterSerie.color,
                                        }}
                                    />
                                    &nbsp;
                                    {s.filterSerie.name}
                                </td>
                                {values.map((v, i) => (
                                    <td key={i}>{v}</td>
                                ))}
                            </tr>
                        );
                    })}
                </Table>
            </div>
        </div>
    );
}
